module.exports = __webpack_public_path__ + "static/media/solidity_engineer.7d06e867.svg";